export const onDomReady = (callbackFn: () => void) => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callbackFn, { once: true });
  } else {
    callbackFn();
  }
};
